import React from "react";

const AccessCardFormFields = ({ accessCard, onChange, user, users }) => (
  <React.Fragment>
    <div className="form-group">
      <label className="control-label" htmlFor="firstname">
        Fornavn
      </label>
      <input
        onChange={e => onChange(["accessCard", "firstname"], e.target.value)}
        value={accessCard.firstname}
        id="firstname"
        name="firstname"
        type="text"
        placeholder="Navn"
        className="form-control input-md"
        required
      />
    </div>

    <div className="form-group">
      <label className="control-label" htmlFor="surname">
        Etternavn
      </label>
      <input
        onChange={e => onChange(["accessCard", "surname"], e.target.value)}
        value={accessCard.surname}
        id="surname"
        name="surname"
        type="text"
        placeholder="Navnesen"
        className="form-control input-md"
        required
      />
    </div>

    {users && (
      <div className="form-group">
        <label className="control-label" htmlFor="company">
          Selskap
        </label>
        <div className="input-group mb-2">
          <select
            onChange={e => onChange(["accessCard", "user_id"], e.target.value)}
            id="company"
            name="company"
            className="form-control"
            value={accessCard.user_id}
            required
          >
            <option value="">Velg</option>
            {Object.keys(users).map(id => (
              <option key={users[id].id} value={users[id].id}>
                {users[id].company}
              </option>
            ))}
          </select>
        </div>
      </div>
    )}

    <div className="form-group">
      <label className="control-label" htmlFor="accesslevel">
        Adgangsnivåer
      </label>
      {accessCard.access_levels.map(
        (al, idx) =>
          al !== null && (
            <div key={`access_level-${idx}`} className="input-group mb-2">
              <select
                onChange={e =>
                  onChange(["accessCard", "access_levels", idx], e.target.value)
                }
                key={`access_level-${idx}`}
                id="accesslevel"
                value={al}
                name="accesslevel"
                className="form-control"
                required
                disabled={!user}
              >
                <option value="">Velg</option>
                {user &&
                  user.access_levels.map(accessLevel => (
                    <option key={accessLevel.id} value={accessLevel.id}>
                      {accessLevel.name}
                    </option>
                  ))}
              </select>
              {idx !== 0 && (
                <div className="input-group-append">
                  <button
                    className="btn btn-danger"
                    type="button"
                    onClick={() =>
                      onChange(["accessCard", "access_levels", idx], null)
                    }
                  >
                    Fjern
                  </button>
                </div>
              )}
            </div>
          )
      )}
      <button
        id="accessCard"
        type="button"
        onClick={() =>
          onChange(
            ["accessCard", "access_levels", accessCard.access_levels.length],
            ""
          )
        }
        name="accessCard"
        className="btn btn-primary"
      >
        Legg til adgangsnivå
      </button>
    </div>

    <div className="form-group">
      <label className="control-label" htmlFor="pin">
        PIN-kode
      </label>
      <input
        onChange={e =>
          onChange(["accessCard", "pin"], e.target.value.replace(/[^0-9]+/, ""))
        }
        value={accessCard.pin}
        id="pin"
        name="pin"
        type="text"
        maxLength="4"
        minLength="4"
        placeholder="1234"
        className="form-control input-md"
        required
      />
    </div>

    <div className="form-group">
      <label className="control-label" htmlFor="note">
        Merknader <small>(valgfritt)</small>
      </label>
      <textarea
        onChange={e => onChange(["accessCard", "note"], e.target.value)}
        value={accessCard.note || ""}
        className="form-control"
        id="note"
        name="note"
      />
    </div>
  </React.Fragment>
);

export default AccessCardFormFields;



// WEBPACK FOOTER //
// ./src/components/AccessCardFormFields.js